module.exports = __webpack_public_path__ + "media/images/agile-indicator-icon-c9a0ad1b53eb1c9744a9ebdb5f1828bf.png";